export default {
  // Header Section
  "discover_your": "உங்கள்",
  "career_path": "தொழில் பாதை",
  "professional_destiny_analysis": "தொழில்வாழ்க்கை விதி பகுப்பாய்வு",
  "career_report_description": "வேத ஜோதிடத்தின் அடிப்படையில் விரிவான தொழில் பகுப்பாய்வுடன் உங்கள் தொழில்முறை திறனைத் திறக்குங்கள். உகந்த தொழில் பாதைகள், வணிக வாய்ப்புகள், வேலை மாற்றங்களுக்கான நேரம், மற்றும் வெற்றிக்கான திட்டங்கள் குறித்து நுண்ணறிவுகளைப் பெறுங்கள்.",

  // Service Information
  "enter_details_for_career_analysis": "தொழில் பகுப்பாய்விற்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_career_analysis": "முழுமையான தொழில் பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_career_analysis_note": "உங்கள் தொழில்முறை திறன்கள் மற்றும் தொழில் சாலைவரைபடத்தின் ஆழப்பகுப்பாய்வு",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_career_influence": "உங்கள் பெயர், உங்கள் தொழில்முறை கண்ணியத்தையும் வெற்றி முறைபாடுகளையும் பாதிக்கிறது",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_career_path": "தொழில்முகமான கிரக நிலைகளை நிர்ணயிக்க இவை அவசியம்",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_critical_for_career": "துல்லியமான வேலை வீடு (10ஆம் வீடு) கணக்கீடுகளுக்கு சரியான நேரம் தேவை",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "location_essential_for_career": "இடம், தொழிலைப் பாதிக்கும் கிரக நிலைகளில் மாற்றம் உண்டாக்கும்",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் தொழில் பகுப்பாய்வு தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Career Features
  "ideal_career_paths": "உகந்த தொழில் பாதைகள்",
  "professional_strengths_analysis": "தொழில்முறை வலிமைகள் பகுப்பாய்வு",
  "business_prospects_guidance": "வணிக வாய்ப்புகள் வழிகாட்டுதல்",
  "career_timing_predictions": "தொழில் நேர முன்கணிப்புகள்",
  "skill_development_recommendations": "திறன் மேம்பாட்டு பரிந்துரைகள்",
  "pdf_download": "முழுமையான PDF அறிக்கை",

  "what_you_get": "உங்கள் தொழில் பகுப்பாய்வில் உள்ளவை",
  "detailed_career_roadmap": "விரிவான தொழில் சாலைவரைபடு",
  "professional_strengths_weaknesses": "தொழில்முறை வலிமைகள் & பலவீனங்கள்",
  "business_entrepreneurship_guidance": "வணிகம் & தொழில்முனைவு வழிகாட்டுதல்",
  "career_transition_timing": "தொழில்மாற்ற நேர நிர்ணயம்",

  // Actions & Buttons
  "pay_and_generate_analysis": "என் தொழில் பகுப்பாய்வை பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "பகுப்பாய்வு உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "career_analysis_processing": "உங்கள் தொழில் பகுப்பாய்வை எங்கள் வேத ஜோதிட நிபுணர்கள் தயாரித்து வருகின்றனர். உங்கள் தொழில்முறை திறன் மற்றும் உகந்த தொழில் பாதைகள் குறித்த விரிவான நுண்ணறிவுகள் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_12_hours_delivery_note": "உங்கள் விரிவான தொழில் அறிக்கை 12 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் கிடைக்கும்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் தொழில் பகுப்பாய்வு தொகுப்பு",
  "detailed_career_report": "முழுமையான தொழில் அறிக்கை (PDF)",
  "suitable_career_options": "உகந்த தொழில் விருப்பங்கள் & துறைகள்",
  "professional_development_plan": "தொழில்முறை வளர்ச்சி திட்டம்",
  "success_timing_analysis": "வெற்றி நேர பகுப்பாய்வு",
  "entrepreneurship_assessment": "தொழில்முனைவு மதிப்பீடு",

  // Visual Content
  "sample_career_analysis": "மாதிரி தொழில் பகுப்பாய்வு",
  "ideal_career_field": "உகந்த தொழில் துறை",
  "sample_career_description": "தொழில்நுட்பம் & புதுமை — வலுவான பகுப்பாய்வு மற்றும் தலைமையாற்றும் திறன்",
  "sample_career_preview": "உங்கள் தனிப்பயன் தொழில் பகுப்பாய்வின் முன்னோட்டம் — துறை பரிந்துரைகளுடன்",
  "career_fields": "தொழில் துறைகள்",

  // Career Field Types
  "technology": "தொழில்நுட்பம்",
  "healthcare": "சுகாதாரம்",
  "finance": "நிதி",
  "creative_arts": "படைப்புக் கலைகள்",
  "education": "கல்வி",
  "business": "வணிகம்",

  // Status & Processing
  "your_career_analysis_status": "உங்கள் தொழில் பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் தொழில் திறன் ஆய்வு செய்யப்படுகிறது",
  "analysis_processing_message": "உங்கள் ஜாதகக் கிரக நிலைகளை ஆய்ந்து, உகந்த தொழில் பாதையும் நேர அமைப்பும் நிர்ணயிக்கப்படுகின்றன.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_12_hours": "அறிக்கை 12 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "தொழில் ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // Career-Specific Elements
  "tenth_house": "10ஆம் வீடு (தொழில் வீடு)",
  "ascendant_lord": "லக்ன அதிபதி",
  "career_planets": "தொழிலைப் பாதிக்கும் கிரகங்கள்",
  "professional_dasha": "தொழில்முறை தசா காலங்கள்",
  "career_yogas": "தொழில் யோகங்கள்",
  "success_indicators": "வெற்றி காட்டிகள்",

  // Career Analysis Sections
  "natural_talents": "இயல்பான திறன்கள் & திறமைகள்",
  "professional_personality": "தொழில்முறை தன்மை",
  "leadership_qualities": "தலைமைத்துவ பண்புகள்",
  "work_preferences": "பணிச்சூழல் விருப்பங்கள்",
  "career_motivations": "தொழில் உந்துதல்கள்",
  "professional_challenges": "தொழில்முறை சவால்கள்",

  // Suitable Career Paths
  "recommended_careers": "பரிந்துரைக்கப்படும் தொழில் பாதைகள்",
  "alternative_careers": "மாற்றுத் தொழில் விருப்பங்கள்",
  "avoid_careers": "தவிர்க்க வேண்டிய தொழில்கள்",
  "freelancing_potential": "ஃப்ரீலான்சிங் திறன்",
  "government_vs_private": "அரசு vs தனியார் துறை",
  "international_opportunities": "சர்வதேச தொழில் வாய்ப்புகள்",

  // Business & Entrepreneurship
  "business_acumen": "வணிக நுண்ணறிவு",
  "entrepreneurial_skills": "தொழில்முனைவு திறன்கள்",
  "partnership_compatibility": "வணிக கூட்டாண்மை இணக்கம்",
  "investment_timing": "முதலீட்டு நேர அமைப்பு",
  "business_sectors": "உகந்த வணிகத் துறைகள்",
  "startup_potential": "ஸ்டார்ட்அப் வெற்றித் திறன்",

  // Professional Development
  "skill_enhancement": "திறன் மேம்படுத்த வேண்டிய பகுதிகள்",
  "educational_recommendations": "கல்வி தொடர்பான பரிந்துரைகள்",
  "certification_suggestions": "சான்றிதழ் பரிந்துரைகள்",
  "mentorship_guidance": "மென்டார்ஷிப் வழிகாட்டுதல்",
  "networking_strategies": "நெட்வொர்க்கிங் உத்திகள்",
  "personal_branding": "பர்சனல் பிராண்டிங் குறிப்புகள்",

  // Career Timing
  "career_growth_periods": "தொழில் வளர்ச்சி காலங்கள்",
  "job_change_timing": "வேலை மாற்றத்திற்கான உகந்த நேரம்",
  "promotion_periods": "பதவி உயர்வுக்கான சாதக காலங்கள்",
  "salary_negotiation_timing": "சம்பள பேச்சுவார்த்தை நேரம்",
  "business_launch_timing": "வணிக துவக்க நேரம்",
  "retirement_planning": "ஓய்வு திட்டமிடல் வழிகாட்டுதல்",

  // Success Strategies
  "professional_networking": "தொழில்முறை நெட்வொர்க்கிங்",
  "workplace_relationships": "பணியிட உறவுகள்",
  "conflict_resolution": "மோதல் தீர்க்கும் திறன்கள்",
  "stress_management": "தொழில்முறை மனஅழுத்த மேலாண்மை",
  "work_life_balance": "வேலை-வாழ்க்கை சமநிலை",
  "career_setback_recovery": "தொழில் பின்னடைவு மீட்பு",

  // Financial Aspects
  "earning_potential": "வருமானத் திறன்",
  "wealth_accumulation": "செல்வச் சேர்க்கை முறைபாடுகள்",
  "financial_planning": "நிதித் திட்டமிடல் ஆலோசனைகள்",
  "investment_guidance": "முதலீட்டு வழிகாட்டுதல்",
  "passive_income_opportunities": "நிச்பந்த வருமான வாய்ப்புகள்",
  "financial_security_timing": "நிதி பாதுகாப்பு காலவரிசை",

  // Industry-Specific Guidance
  "it_software": "ஐடி & மென்பொருள்",
  "banking_finance": "வங்கித்துறை & நிதி",
  "healthcare_medical": "சுகாதாரம் & மருத்துவம்",
  "education_training": "கல்வி & பயிற்சி",
  "media_entertainment": "ஊடகம் & பொழுதுபோக்கு",
  "manufacturing_engineering": "தயாரிப்பு & பொறியியல்",
  "sales_marketing": "விற்பனை & மார்க்கெட்டிங்",
  "consulting_services": "ஆலோசனை & சேவைகள்",

  // Professional Relationships
  "boss_relationships": "மேலதிகாரிகளுடன் உறவுகள்",
  "colleague_dynamics": "சக ஊழியர் இயக்கவியல்",
  "team_leadership": "குழுத் தலைமையாற்றும் நடை",
  "client_relationships": "கிளையண்ட் உறவு மேலாண்மை",
  "vendor_partnerships": "வெண்டர் & கூட்டாண்மை மேலாண்மை",

  // Career Remedies
  "career_remedies": "தொழில் முன்னேற்றப் பரிகாரங்கள்",
  "professional_gemstones": "தொழில்முறை ரத்தினங்கள்",
  "career_mantras": "தொழில் வெற்றி மந்திரங்கள்",
  "workplace_vastu": "பணியிட வாஸ்து குறிப்புகள்",
  "professional_colors": "தொழில்முறை அதிர்ஷ்ட நிறங்கள்",
  "career_fasting": "தொழில் பலனை உயரும் நோன்புகள்"
};
